"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodthirstyAbilityHandler = exports.BloodthirstyActorAbilityFactory = exports.BloodthirstyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AttributeType_1 = require("../../core/enums/AttributeType");
class BloodthirstyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bloodthirsty;
        this.__typeName = "Bloodthirsty";
    }
}
exports.BloodthirstyAbilityArgs = BloodthirstyAbilityArgs;
let BloodthirstyActorAbilityFactory = class BloodthirstyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bloodthirsty", "Self", 4);
    }
};
BloodthirstyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bloodthirsty")
], BloodthirstyActorAbilityFactory);
exports.BloodthirstyActorAbilityFactory = BloodthirstyActorAbilityFactory;
let BloodthirstyAbilityHandler = class BloodthirstyAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Power")),
                        new core_1.LeechEffectArgs(5)
                    ], false)
                });
            }
        });
    }
};
BloodthirstyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bloodthirsty)
], BloodthirstyAbilityHandler);
exports.BloodthirstyAbilityHandler = BloodthirstyAbilityHandler;
